import { useQuery } from '@tanstack/react-query'
import { getMaintenance } from '../services/loginSevices'

export function useMaintenance() {
  return useQuery({
    queryKey: ['maintenance'],
    queryFn: () => getMaintenance(),
  })
}
